import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { AppUtils, Constants, Highcharts$, Moment$, WarningDialog } from '../../../../shared/index';
import { PlantServiceService, EnergyService, SiteService, CommonService } from '../../../../services/index';
import { Chart } from 'angular-highcharts';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { combineLatest, forkJoin } from 'rxjs';
import { Hierarchy, FeatureItemFlatNode, FeatureItemNode, ProductModel } from '../../../../models/index';
import * as ObjectUtils from 'util';
import { TagParameters } from '../../../../models/index';
import { DataTagComponent } from '../data-tag/data-tag.component';
import { Highcharts$ as Highcharts, IrradianceGraphTypeEnum } from 'src/app/shared/index';
@Component({
  selector: 'app-specific-energy',
  templateUrl: './specific-energy.component.html',
  styleUrls: ['./specific-energy.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: Constants.DATE_RANGES_PROVIDER_FORMAT },
  ]
})
export class SpecificEnergyComponent extends Hierarchy implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tree') tree;
  siteId: string; startDate: string; endDate: string;
  isST_load: boolean; isMeter: undefined | boolean = undefined;
  isFirstLoaded = true;
  shifts: any;
  dateRange: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    'Yesterday': [Moment$().subtract(1, 'days'), Moment$().subtract(1, 'days')],
    'Last 7 Days': [Moment$().subtract(6, 'days'), Moment$()],
    'Last 30 Days': [Moment$().subtract(29, 'days'), Moment$()],
    'This Month': [Moment$().startOf('month'), Moment$().toDate()],
  };
  totalEnergy = '';
  columnchart: Chart;
  rateChart: Chart;
  currentNode: {
    nodeData: any, metersId: any, nodeTitle: string,
    nodeType: string, loadId: string; meterId: string, loadRId: string, kwRating: any
  } = Object.assign({});

  displayUpdateTagAlert = true;
  tagParameters: TagParameters;
  isNotViewFull = true;
  buttons: any;
  firstLeaftNode: any;
  productsOfSite: ProductModel[];;
  selectedProducts = 'all';
  liveEQChartDataToExcel: any;
  liveEQAnalysisChartConfig: any;
  useShiftwise = "no";
  currentData: any;
  hasChart = false;
  isAdmin = false;
  //
  currentSuccessPercent: number;
  currentSuccessMessage = '';
  //
  DEFAULT_SUCCESS_PERCENT = 50;
  MESSAGE_MEET_TARGET = 'E/Q met the Target for selected date range';
  MESSAGE_NOT_MEET_TARGET = 'E/Q does not meet the Target for selected date range';
  DEFAULT_CHART_HEIGHT = 585;
  //
  currentDisplayItem: String; // all, energy, production, specific, target
  DISPLAY_ALL = 'all';
  DISPLAY_ENERGY = 'energy';
  DISPLAY_PRODUCTION = 'production';
  DISPLAY_TARGET = 'target';
  //  
  TIME_RANGE_DAILY = 'daily';
  TIME_RANGE_HOURLY = 'hourly';
  TIME_RANGE_WEEKLY = 'weekly';
  TIME_RANGE_MONTHLY = 'monthly';
  TIME_RANGE_YEARLY = 'yearly';
  currentTimeRange = this.TIME_RANGE_DAILY;
  MONTHS_LIST = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private activeRoute: ActivatedRoute,
    private plantService: PlantServiceService,
    private siteService: SiteService,
    private commonService: CommonService,
    public dialog: MatDialog,
    private energyService: EnergyService) {
    super();
    this.tagParameters = new TagParameters();
    this.alwaysShowCalendars = true;
    this.dateRange = { startDate: Moment$().subtract(1, 'days'), endDate: Moment$().subtract(1, 'days') };
  }

  ngOnInit() {
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe(routeParams => {
      this.siteId = routeParams.siteId;
      forkJoin(
        this.plantService.getShiftsBySiteId(this.siteId),
        this.siteService.getTreeConfiguration(this.siteId, ['treeData'])
      ).subscribe(([shifts, treeConfig]) => {
        this.shifts = shifts;
        this.dataSource.data = [];
        if (treeConfig !== undefined && treeConfig.treeData !== undefined) {
          // Data api is wrong. Can not use checkbox
          const dataPaser = JSON.parse(treeConfig.treeData);
          this.dataSource.data = this.buildFileTree(dataPaser[0], this.dataSource.data, null);
          this.tree.treeControl.expandAll();
          // Check if current user is Admin or not -> allow select more than 10 days
          const currentUser = JSON.parse(localStorage.getItem('currentUser'));
          this.isAdmin = 'admin' === currentUser.role.code.toLowerCase();

          this.getFirstLoad(this.dataSource.data);
        }
      });
    });
    this.initSolidGauge(0);
  }

  ngAfterViewInit(): void {
    this.tree.treeControl.expandAll();
    // collapseAll
    const seft = this;
    window.onresize = function () {
      const dom = document.getElementById('chartContainer');
      if (seft.commonService.isNullOrUndefined(dom)) {
        return;
      }
      if (dom && dom.clientHeight > seft.DEFAULT_CHART_HEIGHT) {
        setTimeout(() => {
          dom.setAttribute('height', seft.DEFAULT_CHART_HEIGHT + '');
        }, 200);
      }
      if (document.fullscreenElement) {
        seft.columnchart.ref.setSize(document.documentElement.clientWidth, document.documentElement.clientHeight);
      } else {
        seft.columnchart.ref.setSize(dom.clientWidth, dom.clientHeight < seft.DEFAULT_CHART_HEIGHT ? dom.clientHeight : seft.DEFAULT_CHART_HEIGHT);

      }
    };
    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    document.addEventListener('fullscreenchange', function () {
      if (seft.columnchart.ref) {
        seft.columnchart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull ? seft.buttons.contextButton.menuItems.slice(1, 2) :
                  seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }

  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', function () { });
  }

  private onChartLoaded = () => {
    const self = this;
    setTimeout(function () {
      if (self.rateChart !== undefined) {
        const point = <any>self.rateChart.ref.series[0].points[0];
        point.onMouseOver();
        self.rateChart.ref.tooltip.refresh(point);
      }
    }, 200);
  }

  private initSolidGauge = (dataChart?: any, isEnergy = false) => {
    const textColor = this.currentSuccessPercent >= this.DEFAULT_SUCCESS_PERCENT ? '#307bbb' : '#f15c80';
    const text = this.currentSuccessPercent >= this.DEFAULT_SUCCESS_PERCENT ? 'Success' : 'Failed';

    const options = {
      chart: {
        type: 'solidgauge',
        height: 120,
        width: 120,
        events: {
          load: this.onChartLoaded
        }
      },
      title: {
        text: '',
        style: {
          fontSize: '12px'
        }
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false
      },
      tooltip: {
        alwaysVisible: true,
        borderWidth: 0,
        backgroundColor: 'none',
        shadow: false,
        style: {
          fontSize: '14px'
        },
        pointFormat: `<span style="font-size:15px; color: ${textColor}; font-weight: bold">${text}</span>`,
        positioner: function (labelWidth, labelHeight) {
          return {
            x: (this.chart.chartWidth - labelWidth) / 2,
            y: (this.chart.plotHeight / 2) - 5
          };
        }
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [{ // Track for Stand
          innerRadius: '100%',
          backgroundColor: '#E7EBEF',
          borderWidth: 0
        }]
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: []
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: true
        }
      },
      series: [{
        name: text,
        data: [{
          color: '#307bbb',
          radius: '100%',
          innerRadius: '90%',
          y: dataChart
        }]
      }]
    };
    this.alwaysVisibleTooltip();
    this.rateChart = new Chart(<any>options);
  }

  private alwaysVisibleTooltip = () => {
    // tslint:disable-next-line:no-shadowed-variable
    Highcharts$.wrap(Highcharts$.Tooltip.prototype, 'hide', function (p, delay) {
      if (this.options.alwaysVisible) {
        return this.refresh(this.chart.series[0].data[0]);
      }
      p.call(this, delay);
    });
  }

  buildFileTree(obj: any, nodes: FeatureItemNode[], currentSelected: FeatureItemFlatNode): FeatureItemNode[] {
    const node = new FeatureItemNode();
    node.title = obj.title;
    node.id = obj.id;
    node.nodeType = obj.nodeType;
    node.subType = obj.subType;
    node.processRId = obj.processRId !== undefined ? obj.processRId : 'NA';
    node.meterId = obj.meterId !== undefined ? obj.meterId : 'NA';
    node.loadId = obj.loadId !== undefined ? obj.loadId : 'NA';
    node.loadRId = obj.loadRId !== undefined ? obj.loadRId : 'NA';
    node.kwRating = obj.kwRating;
    if (currentSelected != null && currentSelected.id === obj.id) {
      node.selected = true;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      obj.nodes.forEach(element => {
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      });
    }
    return nodes.concat(node);
  }

  /** Toggle the feature item selection. Select/deselect all the descendants node */
  public featureItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.activeNode = node;
    this.setCurrentNode(node);
    this.resetData();
    this.processDataAndDrawChart();
  }

  /** Toggle a leaf feature item selection. Check all the parents to see if they changed */
  public featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.activeNode = node;
    this.setCurrentNode(node);
    this.resetData();
    this.processDataAndDrawChart();
  }

  private getAllMetersIdOfNode = (node: any, metersId: any) => {
    if (node.meterId !== 'NA') {
      metersId.push(node.meterId);
    }
    if (node.nodes !== undefined && node.nodes.length > 0) {
      for (let i = 0; i < node.nodes.length; i++) {
        metersId = this.getAllMetersIdOfNode(node.nodes[i], metersId);
      }
    }
    return metersId;
  }

  private getFirstLoad = (tree: any) => {
    const firstLeaf = this.getFirstLeafOfTree(tree);
    this.activeNode = firstLeaf;
    if (typeof (firstLeaf.is_ST_Load) !== 'undefined' && firstLeaf.is_ST_Load != null && firstLeaf.is_ST_Load) {
      this.isST_load = true;
    } else {
      this.isST_load = false;
    }
    this.setCurrentNode(firstLeaf);
    const node = document.getElementById(firstLeaf.title);
    if (node && node != null) {
      node.dispatchEvent(new Event('click'));
      // this.resetData();
      // this.processDataAndDrawChart();
      this.isFirstLoaded = false;
    }
  }

  private getFirstLeafOfTree = (tree: any, conditions: any = undefined) => {
    let result;
    if (tree !== undefined) {
      for (let i = 0; i < tree.length; i++) {
        if (this.hasChildNode(tree[i])) {
          result = this.getFirstLeafOfTree(tree[i].nodes, conditions);
        } else {
          let conditionEvaluated = true;
          if (conditions !== undefined) {
            const propNames = Object.keys(conditions);
            for (let j = 0; j < propNames.length; j++) {
              conditionEvaluated = conditionEvaluated && tree[i][propNames[j]] === conditions[propNames[j]];
              if (conditionEvaluated === false) {
                break;
              }
            }
          }
          if (tree[i].loadId !== undefined && conditionEvaluated) {
            result = tree[i];
            tree[i].selected = true;
            break;
          } else {
            continue;
          }
        }
        if (result !== undefined) {
          break;
        }
      }
    }
    return result;
  }

  private hasChildNode = (branch: any): boolean => {
    return (branch.nodes === undefined || branch.nodes.length === 0) ? false : true;
  }

  private setCurrentNode = (node: FeatureItemNode | FeatureItemFlatNode) => {
    this.isST_load = true;
    this.currentNode.nodeData = node;
    const metersId = this.getAllMetersIdOfNode(node, []);
    this.currentNode.metersId = AppUtils.uniqueArray(metersId);
    this.currentNode.nodeTitle = node.title;
    this.currentNode.nodeType = node.nodeType;
    if (node.nodeType === Constants.NODE_TYPE.METER) {
      this.isMeter = true;
      this.currentNode.meterId = node.meterId;
      this.currentNode.loadId = node.meterId;
      this.isST_load = false;
    } else if (node.nodeType === Constants.NODE_TYPE.LOAD) {
      this.isMeter = false;
      this.isST_load = false;
      this.currentNode.meterId = node.meterId;
      this.currentNode.loadId = node.loadId;
      this.currentNode.loadRId = node.loadRId;
      this.currentNode.kwRating = node.kwRating;
      if (node.subType !== undefined && node.subType === 'StratificationTank') {
        this.isST_load = true;
      }
    }
    this.energyService.getProductsBySiteId(this.siteId, this.currentNode.loadId).subscribe((data) => {
      this.productsOfSite = data;
    });
  }

  public onChangeDateRange = () => {
    if (Moment$(this.dateRange.endDate).diff(Moment$(this.dateRange.startDate), 'days') >= 31) {
      this.commonService.showDialogMessage('Note: Data display limited to 31 days. Please select duration not more than 31 days');
      return;
    }
    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
    if (this.isFirstLoaded === false && ObjectUtils.isNullOrUndefined(this.siteId) === false) {
      this.resetData();
      this.processDataAndDrawChart();
    }
  }

  // datesUpdated(event) {
  //   this.resetData();
  //   this.processDataAndDrawChart();
  // }

  private transformDate = () => {
    this.startDate = Moment$(this.dateRange.startDate).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
    this.endDate = Moment$(this.dateRange.endDate).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
  }

  private processDataAndDrawChart = () => {
    if (this.isST_load === false) {
      this.transformDate();
      // Validate date range
      // Admin Users can view data for > 10 Days
      // Site Users cannot View data > 10 Days
      if (Moment$(this.dateRange.endDate).diff(Moment$(this.dateRange.startDate), 'days') > 10 && !this.isAdmin) {
        this.onOpenAlertBox('Note: Data display limited to 10 days. Please select duration not more than 10 days');
      } else {
        const params = {
          siteId: this.siteId,
          startDate: this.startDate,
          // startDate: '2018-03-28',
          endDate: this.endDate,
          // endDate: '2018-04-29',
          meterIds: this.currentNode.metersId,
          // meterIds: ['719'],
          loadId: this.currentNode.loadId,
          // loadId: 'MakHeating1143',
          products: this.selectedProducts === 'all' ? null : this.selectedProducts,
          shift: null
        };
        const t = this;
        setTimeout(() => {
          t.energyService.fetchDataForEbyQAnalysis(params).subscribe((data) => {
            if (data && data.result && data.result.length > 0) {
              this.hasChart = true;

              t.currentData = Object.assign({}, data);

              //Process pie chart data
              let successCount = 0;
              for (var i = 0; i < data.result.length; i++) {
                if (data.result[i].actualEbyQ <= data.result[i].plannedEbyQ) {
                  successCount++;
                }
              }
              t.currentSuccessPercent = Math.round((successCount / data.result.length) * 100);
              t.currentSuccessMessage = t.currentSuccessPercent >= t.DEFAULT_SUCCESS_PERCENT ? t.MESSAGE_MEET_TARGET : t.MESSAGE_NOT_MEET_TARGET;
              t.initSolidGauge(t.currentSuccessPercent);

              // Draw column chart
              t.drawChart();
            }
          });
        }, 600);
      }
    } else {
      // Show message box
      this.onOpenAlertBox('Please choose any relevant load to view data.');
    }
  }

  private getAreaChartConfigOption = () => {
    const self = this;
    const option = {
      chart: {
        zoomType: 'x',
        height: self.DEFAULT_CHART_HEIGHT
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      yAxis: [{
        labels: {
          format: '{value}',
          style: {
            color: '#7CB5EC',//blue
            fontSize: '14px'
          }
        },
        title: {
          text: 'Actual daily(parts produced)',
          style: {
            color: '#7CB5EC',
            fontweight: 'bold',
            fontSize: '14px'
          }
        },
        reversedStacks: false

      }, {
        labels: {
          format: '{value}',
          style: {
            color: '#434348',//purple
            fontSize: '14px'
          }
        },
        title: {
          text: 'kWh/Day',
          style: {
            color: '#434348',
            fontweight: 'bold',
            fontSize: '14px'
          }
        },

        opposite: true,
        reversedStacks: false
      }, {
        title: {
          text: 'kWh/PC',//'Actual kWh/PC',
          style: {
            color: '#434348',//'#90ED7D',//red
            fontSize: '14px'
          }
        },
        labels: {
          format: '{value} ',
          style: {
            color: '#434348',//'#90ED7D',
            fontSize: '14px'
          }
        },
        opposite: true
      }
      ],
      xAxis: {
        title: {
          text: ''
        },
        type: 'date',
        labels: {},
        tickLength: 10,
        startOnTick: true,
        endOnTick: true,
        categories: [],
        crosshair: true,
        events: {}
      },
      plotOptions: {
        series: {
          marker: {
            enabled: true
          },
          turboThreshold: 0,
          threshold: null,
          point: {
            events: {
              click: function (callback) {
                return callback;
              }
            }
          },
        }
      },
      series: [],
      tooltip: {
        shared: true,
        crosshairs: true,
        formatter: function () {
          // tslint:disable-next-line:max-line-length
          let toolTipData = '';
          if (self.currentTimeRange === self.TIME_RANGE_DAILY) {
            toolTipData = '<b><font style="font-size: 10px;">' + Moment$(this.x).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT) + '</font></b><br/>';
          } else {
            toolTipData = '<b><font style="font-size: 10px;">' + this.x + '</font></b><br/>';
          }
         
          for (let i = 0; i < this.points.length; i++) {
            const myPoint = this.points[i];
            // tslint:disable-next-line:max-line-length
            let suffix = '<span style="color:' + myPoint.series.data[myPoint.point.index].color + '">\u25CF</span>   ' + myPoint.series.name + ': ';
            if (myPoint.point.low && myPoint.point.high) {
              suffix += '<b>' +
                Highcharts$.numberFormat(myPoint.point.low, Constants.DECIMAL_FORMAT.DECIMAL_NO) +
                ' - ' +
                Highcharts$.numberFormat(myPoint.point.high, Constants.DECIMAL_FORMAT.DECIMAL_NO) + '</b><br/>';
            } else {
              suffix += '<b>' + Highcharts$.numberFormat(myPoint.y, Constants.DECIMAL_FORMAT.DECIMAL_NO) + '</b><br/>';
            }

            if (myPoint.series.name.indexOf('Data Tags') !== -1) {
              // tslint:disable-next-line:max-line-length
              suffix = '<span style="color:' + myPoint.series.data[myPoint.point.index].color + '">\u25CF</span>  ' + myPoint.series.name + ' : Present <br/>';
            }
            if (myPoint.series.name.indexOf('Fuel Consumption') !== -1) {
              // tslint:disable-next-line:max-line-length
              suffix = '<span style="color:' + myPoint.series.data[myPoint.point.index].color + '">\u25CF</span>   ' + myPoint.series.name + ': ' + Highcharts$.numberFormat(myPoint.y, Constants.DECIMAL_FORMAT.DECIMAL_NO) + ' (Litres)<br/>';
            }

            toolTipData += suffix;
          }
          return toolTipData;
        }
      }
    };
    return option;
  }

  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = description;
  }

  clickAll(event) {

  }
  clickEnergy(event) {

  }
  clickProduction(event) {

  }
  clickSpecificEnergy(event) {

  }
  clickTarget(event) {

  }

  drawChart() {
    if (this.currentData === undefined || this.currentData === null) {
      return;
    }
    let data = this.currentData.result;
    //
    var categoryArr = [];
    var actualQArr = [];
    var actualEArr = [];
    var actualEbyQArr = [];
    var taragetEbyQArr = [];
    //
    var plannedQArr = [];
    var EfirstShiftArr = [];
    var EsecondShiftArr = [];
    var EnightShiftArr = [];
    var EfourthShiftArr = [];
    var QfirstShiftArr = [];
    var QsecondShiftArr = [];
    var QnightShiftArr = [];
    var QfourthShiftArr = [];

    if (this.currentTimeRange === this.TIME_RANGE_DAILY) {
      for (var i = 0; i < data.length; i++) {
        categoryArr.push(data[i].date);
        //
        actualQArr.push(Number(Highcharts$.numberFormat(data[i].actualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        actualEArr.push(Number(Highcharts$.numberFormat(data[i].actualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        actualEbyQArr.push(Number(Highcharts$.numberFormat(data[i].actualEbyQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        taragetEbyQArr.push(Number(Highcharts$.numberFormat(data[i].plannedEbyQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        //
        plannedQArr.push(Number(Highcharts$.numberFormat(data[i].plannedQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        EfirstShiftArr.push(Number(Highcharts$.numberFormat(data[i].firstshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        EsecondShiftArr.push(Number(Highcharts$.numberFormat(data[i].secondshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        EnightShiftArr.push(Number(Highcharts$.numberFormat(data[i].nightshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        EfourthShiftArr.push(Number(Highcharts$.numberFormat(data[i].fourthshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        QfirstShiftArr.push(Number(Highcharts$.numberFormat(data[i].firstshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        QsecondShiftArr.push(Number(Highcharts$.numberFormat(data[i].secondshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        QnightShiftArr.push(Number(Highcharts$.numberFormat(data[i].nightshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
        QfourthShiftArr.push(Number(Highcharts$.numberFormat(data[i].fourthshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      }
    } else {
      let dataMap = this.getMapData(this.currentTimeRange, data);
      for (let key of Array.from(dataMap.keys())) {
        categoryArr.push(key);

        let mapData = dataMap.get(key);
        //
        actualQArr.push(mapData.get('actualQArr'));
        actualEArr.push(mapData.get('actualEArr'));
        actualEbyQArr.push(mapData.get('actualEbyQArr'));
        taragetEbyQArr.push(mapData.get('taragetEbyQArr'));
        //
        plannedQArr.push(mapData.get('plannedQArr'));
        EfirstShiftArr.push(mapData.get('EfirstShiftArr'));
        EsecondShiftArr.push(mapData.get('EsecondShiftArr'));
        EnightShiftArr.push(mapData.get('EnightShiftArr'));
        EfourthShiftArr.push(mapData.get('EfourthShiftArr'));
        QfirstShiftArr.push(mapData.get('QfirstShiftArr'));
        QsecondShiftArr.push(mapData.get('QsecondShiftArr'));
        QnightShiftArr.push(mapData.get('QnightShiftArr'));
        QfourthShiftArr.push(mapData.get('QfourthShiftArr'));
      }
    }

    if (actualQArr.length == 0) {
      this.onOpenAlertBox("Please Enter Actual Quantity");
      this.hasChart = false;
    }

    this.liveEQAnalysisChartConfig = this.getAreaChartConfigOption();

    let fromDate = '';
    let toDate = '';
    if (data.length <= 0) {
      fromDate = this.startDate;
      toDate = this.endDate;
    } else {
      fromDate = Moment$(data[0].date).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
      toDate = Moment$(data[data.length - 1].date).format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
    }
    // tslint:disable-next-line:max-line-length
    this.liveEQAnalysisChartConfig.title.text = `Specific Energy E/Q Analysis from ${fromDate} to ${toDate} ${this.currentNode.nodeTitle === undefined ? '' : ' at ' + this.currentNode.nodeTitle}`;

    this.liveEQAnalysisChartConfig.xAxis.categories = categoryArr;
    if (this.useShiftwise === "yes") {
      this.liveEQAnalysisChartConfig.plotOptions = {
        column: {
          stacking: 'normal'
        }
      };

      if ([this.DISPLAY_ALL, this.DISPLAY_PRODUCTION].includes(this.currentDisplayItem + '')) {
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('PC_First Shift', QfirstShiftArr, 'column', 0, 'partsProduced'));
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('PC_Second Shift', QsecondShiftArr, 'column', 0, 'partsProduced'));
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('PC_Night Shift', QnightShiftArr, 'column', 0, 'partsProduced'));
        if (this.siteId == "BoscBang56001170" || this.siteId == "RBEIBang56002629") {
          this.liveEQAnalysisChartConfig.series.push(this.initSerie('PC_Fourth Shift', QfourthShiftArr, 'column', 0, 'partsProduced'));
        }
      }
      if ([this.DISPLAY_ALL, this.DISPLAY_ENERGY].includes(this.currentDisplayItem + '')) {
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Energy_First Shift', EfirstShiftArr, 'column', 1, 'energy'));
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Energy_Second Shift', EsecondShiftArr, 'column', 1, 'energy'));
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Energy_Night Shift', EnightShiftArr, 'column', 1, 'energy'));
        if (this.siteId == "BoscBang56001170" || this.siteId == "RBEIBang56002629") {
          this.liveEQAnalysisChartConfig.series.push(this.initSerie('Energy_Fourth Shift', EfourthShiftArr, 'column', 1, 'energy'));
        }
      }
      if ([this.DISPLAY_ALL, this.DISPLAY_TARGET].includes(this.currentDisplayItem + '')) {
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Actual kWh/PC', actualEbyQArr, 'spline', 2));
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Target kWh/PC', taragetEbyQArr, 'spline', 2));
      }
    } else {
      // Total No of pcs produced in day (Q)
      if ([this.DISPLAY_ALL, this.DISPLAY_PRODUCTION].includes(this.currentDisplayItem + '')) {
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Actual daily(parts produced)', actualQArr, 'column', 0, 'parts'));
      }
      // Energy used (E)
      if ([this.DISPLAY_ALL, this.DISPLAY_ENERGY].includes(this.currentDisplayItem + '')) {
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('kWh/Day', actualEArr, 'column', 1, 'energy'));
      }
      if ([this.DISPLAY_ALL, this.DISPLAY_TARGET].includes(this.currentDisplayItem + '')) {
        // Actual E/Q
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Actual kWh/PC', actualEbyQArr, 'spline', 2));
        // Target
        this.liveEQAnalysisChartConfig.series.push(this.initSerie('Target kWh/PC', taragetEbyQArr, 'spline', 2));
      }
    }
    this.columnchart = new Chart(this.liveEQAnalysisChartConfig);
  }

  private initSerie(name: String, data: any, type: String, yAxisIndex: number, stack?: any) {
    return {
      name: name,
      showInLegend: true,
      data: data,
      type: type,
      stack: stack,
      tooltip: {
        valueSuffix: ''
      },
      yAxis: yAxisIndex
    }
  }

  onShiftwiseChanged(event: any) {
    this.drawChart();
  }

  onDisplaysClick(targetItem) {
    this.currentDisplayItem = targetItem;
    this.drawChart();
  }

  private resetData() {
    // Reset data when node changed
    this.currentData = undefined;
    this.currentDisplayItem = this.DISPLAY_ALL;
    this.useShiftwise = "no";
    this.currentSuccessPercent = 0;
    this.currentSuccessMessage = '';
    this.currentTimeRange = this.TIME_RANGE_DAILY;
    this.selectedProducts = 'all';
    this.hasChart = false;
  }

  onTimeRangeChanged(event: any) {
    // this.resetData();
    this.drawChart();
  }

  onClearButtonClicked() {
    this.resetData();
    this.processDataAndDrawChart();
  }

  productSelectclick(event: any) {
    if (event !== null && event !== 'all') {
      this.selectedProducts = event;
    } else {
      this.selectedProducts = null;
    }
    this.resetData();
    this.processDataAndDrawChart();
  }

  private y2k(number) {
    return (number < 1000) ? number + 1900 : number;
  }

  private getWeek(year, month, day) {
    var when = new Date(year, month, day);
    var newYear = new Date(year, 0, 1);
    var offset = 7 + 1 - newYear.getDay();
    if (offset == 8) offset = 1;
    var daynum = ((Date.UTC(this.y2k(year), when.getMonth(), when.getDate(), 0, 0, 0) - Date.UTC(this.y2k(year), 0, 1, 0, 0, 0)) / 1000 / 60 / 60 / 24) + 1;
    var weeknum = Math.floor((daynum - offset + 7) / 7);
    if (weeknum == 0) {
      year--;
      var prevNewYear = new Date(year, 0, 1);
      var prevOffset = 7 + 1 - prevNewYear.getDay();
      if (prevOffset == 2 || prevOffset == 8) weeknum = 53; else weeknum = 52;
    }
    return weeknum;
  }

  private getNumber(numb: any): number {
    if (numb && !(isNaN(numb))) {
      return Number(numb);
    } else {
      return 0;
    }
  }

  private getMapData(type: String, data: any) {
    let dataMap = new Map();
    for (var i = 0; i < data.length; i++) {
      let theDate = new Date(data[i].date);
      let dataKey = '';
      if (type === this.TIME_RANGE_WEEKLY) {
        dataKey = 'Week '
          + this.getWeek(this.y2k(theDate.getFullYear()), theDate.getMonth(), theDate.getDate()).toString();
      }
      if (type === this.TIME_RANGE_MONTHLY) {
        dataKey = this.MONTHS_LIST[theDate.getMonth()].toString() + " " + theDate.getFullYear();
      }
      if (type === this.TIME_RANGE_YEARLY) {
        dataKey = theDate.getFullYear().toString();
      }
      let specificDataMap = new Map();
      if (dataMap.has(dataKey)) {
        specificDataMap = dataMap.get(dataKey);
      }
      // Process data for dataMap
      specificDataMap.set('actualQArr', this.getNumber(specificDataMap.get('actualQArr')) +
        Number(Highcharts$.numberFormat(data[i].actualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('actualEArr', this.getNumber(specificDataMap.get('actualEArr')) +
        Number(Highcharts$.numberFormat(data[i].actualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('actualEbyQArr', this.getNumber(specificDataMap.get('actualEbyQArr')) +
        Number(Highcharts$.numberFormat(data[i].actualEbyQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('taragetEbyQArr', this.getNumber(specificDataMap.get('taragetEbyQArr')) +
        Number(Highcharts$.numberFormat(data[i].plannedEbyQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      //
      specificDataMap.set('plannedQArr', this.getNumber(specificDataMap.get('plannedQArr')) +
        Number(Highcharts$.numberFormat(data[i].plannedQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('EfirstShiftArr', this.getNumber(specificDataMap.get('EfirstShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].firstshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('EsecondShiftArr', this.getNumber(specificDataMap.get('EsecondShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].secondshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('EnightShiftArr', this.getNumber(specificDataMap.get('EnightShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].nightshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('EfourthShiftArr', this.getNumber(specificDataMap.get('EfourthShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].fourthshiftactualE, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      //
      specificDataMap.set('QfirstShiftArr', this.getNumber(specificDataMap.get('QfirstShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].firstshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('QsecondShiftArr', this.getNumber(specificDataMap.get('QsecondShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].secondshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('QnightShiftArr', this.getNumber(specificDataMap.get('QnightShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].nightshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));
      specificDataMap.set('QfourthShiftArr', this.getNumber(specificDataMap.get('QfourthShiftArr')) +
        Number(Highcharts$.numberFormat(data[i].fourthshiftactualQ, Constants.DECIMAL_FORMAT.DECIMAL_NO)));

      // Update to weekMap
      dataMap.set(dataKey, specificDataMap);
    }

    return dataMap;
  }
}